import SuperStorage from './shared/super-storage';

class SuperLocalStorage extends SuperStorage {
  constructor() {
    super(window.localStorage);
  }
}

export let superLocalStorage = new SuperLocalStorage();
